export const getChunks = <T>(arr: T[], size: number): T[][] => {
  return arr.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / size);

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []; // start a new chunk
    }

    resultArray[chunkIndex].push(item);

    return resultArray;
  }, [] as T[][]);
};

export const getUniqueValues = <T>(arr: T[]): T[] => {
  return arr.filter((value, index, self) => self.indexOf(value) === index);
};
